/**
 * Deep-link routing for notifications.
 *
 * Each notification carries optional refs: projectId, projectItemId,
 * orderBatchId. Click semantics:
 *
 *   - batch ref → entity-drilldown on the part with batch highlighted (we
 *     just go to the part page; the batch shows in the batches tab)
 *   - item ref alone → entity-drilldown on the part
 *   - project ref alone → project detail
 *   - no refs → no link (rare; renders as plain row)
 *
 * Returns null when there's nothing useful to link to.
 */

import type { NotificationEvent } from './notification-queries';

export function notificationLinkPath(n: NotificationEvent): string | null {
  if (n.projectId && n.projectItemId) {
    return `/projects/${n.projectId}/items/${n.projectItemId}`;
  }
  if (n.projectId) {
    return `/projects/${n.projectId}`;
  }
  return null;
}
